var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6078",
    "data-name": "Group 6078",
    transform: "translate(-898 -385.685)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9502",
    "data-name": "Ellipse 9502",
    cx: 62,
    cy: 62,
    r: 62,
    transform: "translate(898 385.685)",
    fill: "#0a9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100544",
    "data-name": "Path 100544",
    d: "M7515.967,5672.342s4.394,12.675,16.6,12.465a16.608,16.608,0,0,0,7.751-2.038c6.341-3.386,8.887-10.427,8.887-10.427",
    transform: "translate(-6572.586 -5207.315)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9503",
    "data-name": "Ellipse 9503",
    transform: "translate(924 427)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9504",
    "data-name": "Ellipse 9504",
    transform: "translate(976 427)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9505",
    "data-name": "Ellipse 9505",
    cx: 62,
    cy: 62,
    r: 62,
    transform: "translate(898 385.685)",
    fill: "#0a9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100545",
    "data-name": "Path 100545",
    d: "M7515.967,5672.342s4.394,12.675,16.6,12.465a16.608,16.608,0,0,0,7.751-2.038c6.341-3.386,8.887-10.427,8.887-10.427",
    transform: "translate(-6572.586 -5207.315)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9506",
    "data-name": "Ellipse 9506",
    transform: "translate(924 427)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9507",
    "data-name": "Ellipse 9507",
    transform: "translate(976 427)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFace);
export default __webpack_public_path__ + "static/media/HappyFace.bc8d7fb55b32afebf10c23f56e5e2883.svg";
export { ForwardRef as ReactComponent };